import { useState } from "react";
import { Form, message as AntdMessage } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneNumberField = ({ field, form }) => {
  const [country, setCountry] = useState("us");
  const [isNotified, setIsNotified] = useState(false);

  const handlePhoneChange = (value, countryData) => {
    const formattedValue = value.startsWith("+") ? value : `+${value}`;
    form.setFieldsValue({ [field.name]: formattedValue });
  
    if (countryData.countryCode !== "us" && !isNotified) {
      AntdMessage.warning("If you're outside from US we will verify your account from our end once");
      setIsNotified(true);
    }
  
    if (countryData.countryCode === "us") {
      setIsNotified(false);
    }
  
    setCountry(countryData.countryCode);
  };
  

  return (
    <Form.Item 
      label={field.label} 
      name={field.name} 
      rules={field.rules}
    >
      <PhoneInput
        country={"us"}
        value={form.getFieldValue(field.name)}
        onChange={handlePhoneChange}
        inputStyle={{
          backgroundColor: "#E7E7E7",
          border: "0.4px solid #d9d9d9",
          color: "rgb(87, 91, 97",
          height: "34px",
          width: "351px",
        }}
        buttonStyle={{
          backgroundColor: "#141414",
          border: "1px solid #333",
        }}
        dropdownStyle={{
          backgroundColor: "#141414",
          border: "0.4px solid #d9d9d9",
          color: "white",
        }}
      />
    </Form.Item>
  );
};

export default PhoneNumberField;
